module.exports = __webpack_public_path__ + "static/media/i84.65dc01cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i84.svg
// module id = 206
// module chunks = 12